module.exports = __webpack_public_path__ + "static/media/docx.1b6053c9.svg";